import React from "react";
import {WebService} from "../../module/WebService";
import {AppConfig} from "../../AppConfig";
import LoadingImage from "../LoadingImage";


class AssignCall extends React.Component {

    webService = new WebService();
    urlSearchParams = new URLSearchParams(window.location.search);

    constructor(props) {
        super(props);
        this.state = {serviceState: -1};
        this.getData();
    }

    getData() {
        this.webService.postWithToken(
            AppConfig.server + AppConfig.service.admin.idleCallAvailableOperator,
            JSON.stringify({"id": parseInt(this.urlSearchParams.get("callId"))}),
            this.success.bind(this),
            this.fail.bind(this)
        )
    }

    success(data) {
        this.data = data;
        if (data.hasOwnProperty("data")) {
            this.data = data["data"];
            this.setState({
                serviceState: 1
            });
        } else
            this.fail();
    }

    fail() {
        this.setState({
            serviceState: 2
        });
    }


    render() {
        if (this.state.serviceState === 1) {
            return (
                <div>
                    <h3><strong>Çağrı Ata</strong></h3>
                    <hr/>
                    <strong>Makina Adı:</strong><span> {this.data["trouble"][0]["machineName"]}</span><br/>
                    <strong>Makina Grubu:</strong><span> {this.data["trouble"][0]["machineGroupName"]}</span><br/>
                    <strong>Çağrı Tipi:</strong><span> {this.data["trouble"][0]["troubleName"]}</span><br/>

                    <br/>
                    <table className="table">
                        <thead>
                        <tr>
                            <th scope="col" style={{width: "100px"}}>Sicil No.</th>
                            <th scope="col">Ad</th>
                            <th scope="col">Soyad</th>
                            <th scope="col">Telefon</th>
                            <th scope="col">E-mail</th>
                            <th scope="col" style={{width: "350px"}}>İşlemler</th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.renderUserRow()}
                        </tbody>
                    </table>
                </div>
            )
        } else if (this.state.serviceState === -1) {
            return (
                <LoadingImage/>
            )
        } else {
            return (
                <span>Tanımlı kullanıcı yoktur</span>
            )
        }
    }

    renderUserRow() {
        const data = this.data["user"];
        const userData = [];
        if (data.length > 0) {
            for (let i = 0; i < data.length; i++) {
                const currentData = data[i];

                userData.push(<tr>
                    <th>{currentData["registryCode"]}</th>
                    <td>{currentData["name"]}</td>
                    <td>{currentData["surname"]}</td>
                    <td>{currentData["phone"]}</td>
                    <td>{currentData["mail"]}</td>
                    <td>
                        <button type="button" className="btn btn-primary" data-user="5"
                                onClick={() => this.send(currentData["userId"])}> Seç
                        </button>
                    </td>
                </tr>)
            }
        }
        else {
            userData.push(<td colSpan="6">Uygun operatör bulunamadı</td>);
        }

        return userData;
    }

    send(userId) {
        this.webService.postWithToken(
            AppConfig.server + AppConfig.service.admin.assignCall,
            JSON.stringify({"troubleId": parseInt(this.urlSearchParams.get("callId")), "userId": userId}),
            this.assignSuccess.bind(this),
            this.assignFail.bind(this)
        );
    }

    assignSuccess(data) {
        if (data.hasOwnProperty("assign") && data["assign"] === true) {
            /*let machineMsg = "\nMakina: " + this.data["trouble"][0]["machineName"];
            const userData = this.data["user"];
            let userMsg = "\nOperatör: " + userData["name"] + (userData.hasOwnProperty("surname") ? userData["user"]["surname"] : "");*/
            alert("Başarılı");
            window.location = AppConfig.pages.admin.calls;
        } else {
            if (data.hasOwnProperty("message")) {
                alert(data["message"]);
            } else this.assignFail();
        }
    }

    assignFail() {
        alert("Başarısız");
    }

}

export default AssignCall;